import React, { Component } from 'react'
import './assessment-chart.scss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faAngleDoubleRight,
  faArrowDown,
  faArrowRight,
  faArrowUp
} from '@fortawesome/free-solid-svg-icons'
import {
  ResponsiveContainer,
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  PieChart,
  Pie,
  Cell,
  BarChart,
  Bar
} from 'recharts'
import SchoolUserApi from '../../../apis/student'
import Loading from '../../common/loading/loading'
import EventStudentWinnersList from '../event-student-winners/event-student-winners-list'
import { ImageConstants } from '../../../constants/constants'
import { getImageSource } from '../../../utility/image-source'
import EvalutionReportV2 from '../evaluation-report-v2/evaluation-report'
import LearningOutcome from '../learning-outcome/learning-outcome'
import SessionCache from '../../routes/session-cache'
const colorPallete1 = ['#7FE7AA', '#FF9696']
const colorPallete2 = ['#79DFFF', '#FFB042', '#8B8BF6']
class AssessmentChart extends Component {
  state = {
    eventReport: {},
    eventReportConsolidated: {},
    isLoading: false,
    nationalAverage: 0,
    performanceReport: {},
    surveyTab: false,
    showLearningOutcome: false,
    chart1: {
      schoolData: [],
      overall: []
    },
    chart2: {
      schoolData: [],
      overall: []
    },
    chart3: {
      schoolData: [],
      overall: []
    },
    chart4: {
      schoolData: [],
      overall: []
    }
  }
  constructor(props) {
    super(props)
    this.state.eventReport = props.eventReport
  }

  componentDidMount() {
    const { selectedClass, eventProgress, event } = this.props
    const payload = {}
    if (selectedClass && selectedClass !== 'All') payload.class = selectedClass
    payload.isConsolidatedReport = event.showOverallReport
    this.getEventReport(payload)
    this.getEventConslidatedReport()
    if (eventProgress !== 'baseline') {
      this.getEventNationalAverage(payload)
    }
    this.getEventPerformaceReport(payload)
    this.getSurveryReport()
  }

  onSelectClass = className => {
    this.props.viewDetails('learningOutcome', false, className)
  }

  getEventConslidatedReport = (payload = {}) => {
    const { event } = this.props
    payload.eventId = event._id
    this.setState({
      isLoading: true
    })
    SchoolUserApi.getEventConslidatedReport(payload)
      .then(response => {
        this.setState({
          eventReportConsolidated: response
        })
      })
      .catch(err => {
        console.log(err)
      })
  }

  getEventReport = (payload = {}) => {
    const { event } = this.props
    payload.eventId = event._id
    this.setState({
      isLoading: true
    })
    SchoolUserApi.getEventReport(payload)
      .then(response => {
        this.setState({
          eventReport: response
        })
      })
      .catch(err => {
        console.log(err)
      })
  }

  getSurveryReport = (payload = {}) => {
    const { event } = this.props
    payload.eventId = event._id
    this.setState({
      isLoading: true
    })
    SchoolUserApi.getSurveyReport(payload)
      .then(response => {
        let chart1 = {},
          chart2 = {},
          chart3 = {},
          chart4 = {}
        if (response.chartDetails) {
          const chartDetails = response.chartDetails
          if (chartDetails.chart1) {
            chart1 = chartDetails.chart1
          }
          if (chartDetails.chart2) {
            chart2 = chartDetails.chart2
          }
          if (chartDetails.chart3) {
            chart3 = chartDetails.chart3
          }
          if (chartDetails.chart4) {
            chart4 = chartDetails.chart4
          }
        }
        this.setState({
          chart1,
          chart2,
          chart3,
          chart4
        })
      })
      .catch(err => {
        console.log(err)
      })
  }

  getEventNationalAverage = (payload = {}) => {
    const { event } = this.props
    payload.eventId = event._id
    SchoolUserApi.getEventNationalAverage(payload)
      .then(response => {
        this.setState(
          {
            nationalAverage: response.nationalAverage || 0
          },
          _ => {
            if (this.evaluationReport && payload.class) {
              this.evaluationReport.getEvaluationReport({
                eventId: payload.eventId,
                class: payload.class
              })
              this.learningOutcome.getLearningOutcomes({
                eventId: payload.eventId,
                class: payload.class
              })
            }
          }
        )
      })
      .catch(err => {
        console.log(err)
      })
  }

  getEventPerformaceReport = (payload = {}) => {
    const { event } = this.props
    payload.eventId = event._id
    SchoolUserApi.getEventPerformaceReport(payload)
      .then(response => {
        this.setState({
          performanceReport: response,
          isLoading: false
        })
      })
      .catch(err => {
        console.log(err)
      })
  }

  viewDetails = (screen, showPopup) => {
    this.props.viewDetails(screen, showPopup)
  }

  scrollToPosition = _ => {
    if (this.performanceProgression)
      this.performanceProgression.scrollIntoView()
  }

  getEventWinnersList(payload) {
    const { eventProgress } = this.props
    if (eventProgress === 'resultAnnounced') {
      this.studentWinners.getEventWinnersList(payload)
    }
  }

  renderSkillChart = (baselinePercentage, finishlinePercentage) => {
    return (
      <>
        <div className='skill-chart'>
          <div>
            <div
              className={`horizontal-bar-${Math.round(baselinePercentage) ||
                1} mt-2 text-right`}
            >
              <span>{Math.round(baselinePercentage) || 0}%</span>
            </div>
          </div>
          <div>
            <div
              className={`final-assessment horizontal-bar-${Math.round(
                finishlinePercentage
              ) || 1} mt-2 text-right`}
            >
              <span>{Math.round(finishlinePercentage) || 0}%</span>
            </div>
          </div>
        </div>
      </>
    )
  }
  onSurveyToggle = val => {
    this.setState({
      surveyTab: val
    })
  }
  getSurveryReportJSX = _ => {
    const { event, selectedClass } = this.props
    const { surveyTab, chart1, chart2, chart3, chart4 } = this.state
    return (
      <div className='row mt-5 survey-report'>
        <div className='col'>
          <div className='cw-plain-card cw-plain-card-wrapper-top mr-2 mb-3'>
            <div className='header-text'>
              SURVEY RESULT <span>(All Schools)</span>
            </div>
            {/* <div className='row'>
              <div className='switch-container col-3 mt-3'>
                <div className={`switch-inner`}>
                  <div
                    className={`switch-left ${surveyTab ? 'active' : ''}`}
                    onClick={_ => (!surveyTab ? this.onSurveyToggle(true) : '')}
                  >
                    My School
                  </div>
                  <div
                    className={`switch-right ${!surveyTab ? 'active' : ''}`}
                    onClick={_ => (surveyTab ? this.onSurveyToggle(false) : '')}
                  >
                    Overall
                  </div>
                </div>
              </div>
            </div> */}
            <div className='mt-5'>
              <div className='row'>
                <div className='col-6'>
                  <div className='survey-question'>
                    {chart1.overall && chart1.overall.length
                      ? chart1.overall[0].question
                      : ''}
                  </div>
                  <div className='survey-chart'>
                    <PieChart width={200} height={300}>
                      <Pie
                        data={surveyTab ? chart1.schoolData : chart1.overall}
                        dataKey='value'
                        nameKey='name'
                        cx='50%'
                        cy='50%'
                        outerRadius={100}
                        fill='#8884d8'
                      >
                        {surveyTab
                          ? chart1.schoolData.map((entry, index) => (
                            <Cell
                              key={`cell-${index}`}
                              fill={
                                chart1.schoolData &&
                                  chart1.schoolData.length > 2
                                  ? colorPallete2[index]
                                  : colorPallete1[index]
                              }
                            />
                          ))
                          : chart1.overall.map((entry, index) => (
                            <Cell
                              key={`cell-${index}`}
                              fill={
                                chart1.overall && chart1.overall.length > 2
                                  ? colorPallete2[index]
                                  : colorPallete1[index]
                              }
                            />
                          ))}
                      </Pie>
                    </PieChart>
                  </div>
                  <div className='survey-footer'>
                    {surveyTab
                      ? chart1.schoolData.map((entry, index) => (
                        <div className={`legend legend${index}`}>
                          {entry.name}
                        </div>
                      ))
                      : chart1.overall.map((entry, index) => (
                        <div className={`legend legend${index}`}>
                          {entry.name}
                        </div>
                      ))}
                  </div>
                </div>
                <div className='col-6'>
                  <div className='survey-question'>
                    {chart2.overall && chart2.overall.length
                      ? chart2.overall[0].question
                      : ''}
                  </div>
                  <div className='survey-chart'>
                    <PieChart width={200} height={300}>
                      <Pie
                        data={surveyTab ? chart2.schoolData : chart2.overall}
                        dataKey='value'
                        nameKey='name'
                        cx='50%'
                        cy='50%'
                        outerRadius={100}
                        fill='#8884d8'
                      >
                        {surveyTab
                          ? chart2.schoolData.map((entry, index) => (
                            <Cell
                              key={`cell-${index}`}
                              fill={
                                chart2.schoolData &&
                                  chart2.schoolData.length > 2
                                  ? colorPallete2[index]
                                  : colorPallete1[index]
                              }
                            />
                          ))
                          : chart2.overall.map((entry, index) => (
                            <Cell
                              key={`cell-${index}`}
                              fill={
                                chart2.overall && chart2.overall.length > 2
                                  ? colorPallete2[index]
                                  : colorPallete1[index]
                              }
                            />
                          ))}
                      </Pie>
                    </PieChart>
                  </div>
                  <div className='survey-footer'>
                    {surveyTab
                      ? chart2.schoolData.map((entry, index) => (
                        <div className={`legend legend${index}`}>
                          {entry.name}
                        </div>
                      ))
                      : chart2.overall.map((entry, index) => (
                        <div className={`legend legend${index}`}>
                          {entry.name}
                        </div>
                      ))}
                  </div>
                </div>
                <div className='col-6 mt-5'>
                  <div className='survey-question pb-4'>
                    {chart3.overall && chart3.overall.length
                      ? chart3.overall[0].question
                      : ''}
                  </div>
                  <div className='survey-chart'>
                    <PieChart width={200} height={200}>
                      <Pie
                        data={surveyTab ? chart3.schoolData : chart3.overall}
                        dataKey='value'
                        nameKey='name'
                        cx='50%'
                        cy='50%'
                        outerRadius={100}
                      >
                        {surveyTab
                          ? chart3.schoolData.map((entry, index) => (
                            <Cell
                              key={`cell-${index}`}
                              fill={
                                chart3.schoolData &&
                                  chart3.schoolData.length > 2
                                  ? colorPallete2[index]
                                  : colorPallete1[index]
                              }
                            />
                          ))
                          : chart3.overall.map((entry, index) => (
                            <Cell
                              key={`cell-${index}`}
                              fill={
                                chart3.overall && chart3.overall.length > 2
                                  ? colorPallete2[index]
                                  : colorPallete1[index]
                              }
                            />
                          ))}
                      </Pie>
                    </PieChart>
                  </div>
                  <div className='survey-footer'>
                    {surveyTab
                      ? chart3.schoolData.map((entry, index) => (
                        <div className={`legend secondary-legend${index}`}>
                          {entry.name}
                        </div>
                      ))
                      : chart3.overall.map((entry, index) => (
                        <div className={`legend secondary-legend${index}`}>
                          {entry.name}
                        </div>
                      ))}
                  </div>
                </div>
                <div className='col-6 mt-5'>
                  <div className='survey-question'>
                    {chart4.overall && chart4.overall.length
                      ? chart4.overall[0].question
                      : ''}
                  </div>
                  <div className='survey-chart'>
                    <PieChart width={200} height={300}>
                      <Pie
                        data={surveyTab ? chart4.schoolData : chart4.overall}
                        dataKey='value'
                        nameKey='name'
                        cx='50%'
                        cy='50%'
                        outerRadius={100}
                        fill='#8884d8'
                      >
                        {surveyTab
                          ? chart4.schoolData.map((entry, index) => (
                            <Cell
                              key={`cell-${index}`}
                              fill={
                                chart4.schoolData &&
                                  chart4.schoolData.length > 2
                                  ? colorPallete2[index]
                                  : colorPallete1[index]
                              }
                            />
                          ))
                          : chart4.overall.map((entry, index) => (
                            <Cell
                              key={`cell-${index}`}
                              fill={
                                chart4.overall && chart4.overall.length > 2
                                  ? colorPallete2[index]
                                  : colorPallete1[index]
                              }
                            />
                          ))}
                      </Pie>
                    </PieChart>
                  </div>
                  <div className='survey-footer'>
                    {surveyTab
                      ? chart4.schoolData.map((entry, index) => (
                        <div className={`legend legend${index}`}>
                          {entry.name}
                        </div>
                      ))
                      : chart4.overall.map((entry, index) => (
                        <div className={`legend legend${index}`}>
                          {entry.name}
                        </div>
                      ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  assignHomework = _ => {
    let userInfo = SessionCache.getUser()
    const { event, classes } = this.props
    const classList = []
    classes.forEach(classDetail => {
      classList.push(classDetail.title)
    })
    window.open(
      `/school/students/homework/assign/${userInfo.schoolInfo.schoolCode}/${event._id
      }?class=${classList.join(',')}`
    )
  }

  assignHomeworkByFixedConcept = (selectedClass = '') => {
    let userInfo = SessionCache.getUser()
    const { event, classes } = this.props
    let classList = []
    classes.forEach(classDetail => {
      classList.push(classDetail.title)
    })

    if (selectedClass && selectedClass.class) {
      console.log('inside')
      classList = classList.filter(classItem => classItem === selectedClass.class)
    }

    console.log(classList)

    window.open(
      `/school/students/homework/assign/${userInfo.schoolInfo.schoolCode}/${event._id
      }?class=${classList.join(',')}`
    )
  }


  renderClasswiseHomeworkAssign = _ => {

    let liveEventHomeworkDetail = this.props.liveEventHomeworkDetail

    return (
      <div id='table-scoll' className='table-responsive mt-1'>
        {this.state.isLoading && <Loading style={{ top: '100px' }}></Loading>}
        <table className='table cw-table mb-0 align-items-center student-list'>
          <thead>
            <tr>
              <th className='text-center th-left-radius'>Class</th>
              <th className='text-center'>Chapter</th>
              <th className='text-center'>Concepts</th>
              <th className='text-center th-right-radius'>Preparatory Course</th>
            </tr>
          </thead>
          <tbody className='bg-white'>
            {
              liveEventHomeworkDetail.length && liveEventHomeworkDetail.map(item => (
                <tr tr className='mt-4' >
                  <td className="text-center">{item.class}</td>
                  <td className="padding-for-td">{item.chapterTitle}</td>
                  <td className="">{item.conceptNames.join(',')}</td>
                  <td className="text-center d-flex justify-content-center">
                    {<div className='assign-button cursor-pointer'
                      onClick={() => this.assignHomeworkByFixedConcept(item)}
                    >Assign Homework</div>}
                  </td>
                </tr>
              ))
            }


            {!liveEventHomeworkDetail.length && (
              <tr className='mt-4'>
                <td colSpan='8' className='text-center'>
                  {' '}
                  No Records Found
                </td>
              </tr>
            )}
          </tbody>
        </table>

      </div >
    )

  }

  render() {
    const {
      eventReportConsolidated,
      eventReport,
      nationalAverage,
      performanceReport,
      selectedClassName,
      showLearningOutcome
    } = this.state
    const { selectedClass, event, eventProgress, classes } = this.props
    const isConsolidatedReport = event.showOverallReport
    const studentCount = isConsolidatedReport
      ? eventReportConsolidated.baselineAttemptedUsers
      : eventReport.studentCount
    const baselineUsers = isConsolidatedReport
      ? eventReportConsolidated.baselineAttemptedUsers
      : eventReport.baselineCompletedCount
    const qualifiedUsers = isConsolidatedReport
      ? eventReportConsolidated.qualifiedUsers
      : eventReport.refreshCourseCompleted
    const finalAssessUsers = isConsolidatedReport
      ? eventReportConsolidated.scholarshipAttempted
      : eventReport.finalAssessmentCompletedCount
    const baselineAvgScore = isConsolidatedReport
      ? eventReportConsolidated.averageBaselineScorePercentage
      : eventReport.baselineAvgScore
    const finalAssessmentAvgScore = isConsolidatedReport
      ? eventReportConsolidated.averageFinishlineScorePercentage
      : eventReport.finalAssessmentAvgScore

    const paidUserCount = isConsolidatedReport ? "" : eventReport.paidUserCount


    console.log(eventProgress)

    return (
      <div className='assesment-chart'>
        {this.state.isLoading && <Loading style={{ top: '100px' }}></Loading>}

        <div className='row'>
          <div className='col'>
            <div className='cw-plain-card cw-plain-card-wrapper-top mr-2'>
              <div className='row'>
                <div className='col-9'>
                  <div className='header-text d-flex align-items-center'>
                    Students{' '}
                    {isConsolidatedReport && <span>(All Schools)</span>}
                    <div className='d-flex align-items-center ml-5'>
                      <div className='circle mr-2 circle-bg-1'></div>
                      <div className='count-title'>Signed Up</div>
                    </div>
                    <div className='d-flex align-items-center ml-4'>
                      <div className='circle mr-2 circle-bg-2'></div>
                      <div className='count-title'>Paid</div>
                    </div>
                    <div className='d-flex align-items-center ml-4'>
                      <div className='circle mr-2 circle-bg-3'></div>
                      <div className='count-title'>Attened</div>
                    </div>
                  </div>
                  <div className='student-chart mt-5'>
                    {!isConsolidatedReport && (
                      <div
                        className={`vertical-bar-${Math.round(
                          (studentCount / studentCount) * 100
                        ) || 1}`}
                      ><div className='count-text text-center'>{studentCount}</div></div>
                    )}
                    <div
                      className={`vertical-bar-${Math.round(
                        (paidUserCount / studentCount) * 100
                      ) || 1}`}
                    >
                      <div className='count-text text-center'>{paidUserCount}</div>
                    </div>
                    {/* <div
                      className={`vertical-bar-${Math.round(
                        (qualifiedUsers / studentCount) * 100
                      ) || 1}`}
                    ></div> */}
                    {eventProgress !== 'baseline' && (
                      <div
                        className={`vertical-bar-${Math.round(
                          (finalAssessUsers / studentCount) * 100
                        ) || 1}`}
                      >
                        <div className='count-text text-center'>{finalAssessUsers}</div>
                      </div>
                    )}
                  </div>
                </div>
                <div className='col-3 text-right'>
                  {/* {!isConsolidatedReport && (
                    <div className='count-details pb-2'>
                      <div className='count-number'>{studentCount}</div>
                      <div className='count-title'>Students signed up</div>
                    </div>
                  )}
                  <div className='count-details pb-2'>
                    <div className='count-number'>{paidUserCount}</div>
                    <div className='count-title'>Students Paid</div>
                  </div> */}
                  {/* <div className='count-details pb-2'>
                    <div className='count-number'>{baselineUsers}</div>
                    <div className='count-title'>Taken Baseline Assessment</div>
                  </div>
                  <div className='count-details pb-2'>
                    <div className='count-number'>{qualifiedUsers}</div>
                    <div className='count-title'>Qualified</div>
                  </div> */}

                  {/* {eventProgress !== 'baseline' && (<div className='count-details pb-2'>
                    <div className='count-number'>{finalAssessUsers}</div>
                    <div className='count-title'>
                      Students attened
                    </div>
                  </div>)} */}


                  <div
                    className='view-details cursor-pointer'
                    onClick={_ => this.viewDetails('students')}
                  >
                    {!isConsolidatedReport
                      ? 'View Details'
                      : 'Your School Details'}
                    <FontAwesomeIcon icon={faAngleDoubleRight} />
                  </div>
                </div>
              </div>
              <div className='row name-space mt-2'>
                <div className='col-6 d-flex align-items center flex-gap'>
                  <div className='signed-up-width'>Students Signed Up</div>
                  <div className='signed-up-width'>Students Paid</div>
                  <div className='signed-up-width'>Students Attened</div>
                </div>

              </div>
            </div>
          </div>
          {/* <div className='col-6'> */}
          {/* <div className='cw-plain-card cw-plain-card-wrapper-top ml-2'>
              <div className='header-container'>
                <span className='header-text'>
                  {eventProgress === 'baseline'
                    ? 'BASELINE ASSESSMENT SCORE'
                    : 'IMPROVEMENT'}
                  {isConsolidatedReport && <span>(All Schools)</span>}
                </span>
                {eventProgress === 'resultAnnounced' && baselineAvgScore >= 0 &&
                  finalAssessmentAvgScore >= 0 &&
                  finalAssessmentAvgScore - baselineAvgScore > 0 && (
                    <span className='green-text'>
                      <img
                        className='skill-img'
                        src={getImageSource(ImageConstants.SUCCESS_GREEN)}
                      />{' '}
                      {Math.round(
                        (finalAssessmentAvgScore / baselineAvgScore) * 100 - 100
                      )}
                      % Improvement
                    </span>
                  )}
              </div>
              <div className='pt-4'>
                <div className='count-title'>
                  Average Baseline assessment Score
                </div>
                <div className='mt-2'>
                  <div
                    className={`horizontal-bar-${Math.round(baselineAvgScore) ||
                      1}`}
                  ></div>
                  {Math.round(baselineAvgScore) < 100 && (
                    <div
                      className={`horizontal-bar-${100 -
                        (Math.round(baselineAvgScore) || 1)}`}
                    ></div>
                  )}
                </div>
                <div className='count-number text-center'>
                  {Math.round(
                    baselineAvgScore
                  ) || 0}
                  %
                </div>
              </div>
              {eventProgress !== 'baseline' && (
                <div>
                  <div className='count-title'>
                    Average Finishline assessment Score
                  </div>
                  <div className='mt-4 final-assessment-bar-container'>
                    <div
                      className={`final-assessment horizontal-bar-${Math.round(
                        finalAssessmentAvgScore
                      ) || 1}`}
                    ></div>
                    {Math.round(
                      finalAssessmentAvgScore
                    ) < 100 && (
                      <div
                        className={`final-assessment horizontal-bar-${100 -
                          (Math.round(
                            finalAssessmentAvgScore
                          ) || 1)}`}
                      ></div>
                    )}
                    {!isConsolidatedReport && <div
                      className={`map-pin-${Math.round(nationalAverage) || 0}`}
                    >
                      <img
                        className='cursor-pointer'
                        src={getImageSource(ImageConstants.INDIA_MAP_PIN)}
                      />
                    </div>}
                  </div>
                  <div className='count-number text-center'>
                    {Math.round(
                      finalAssessmentAvgScore
                    ) || 0}
                    %
                  </div>
                  {eventProgress !== "baseline" && 
                  !isConsolidatedReport && 
                  <div className='mb-3 nation-average-container'>
                    <img
                      className='cursor-pointer'
                      src={getImageSource(ImageConstants.INDIA_MAP_ICON)}
                    />{' '}
                    <span className='nation-average-text'>
                      National Average{' '}
                    </span>
                    <span className='nation-average'>
                      {Math.round(nationalAverage)}%
                    </span>
                  </div>}
                </div>
              )}
              <div
                className='view-details text-right mt-4 cursor-pointer mb-4 mr-4'
                onClick={_ => this.viewDetails('improvement')}
              >
                {isConsolidatedReport ? "Your School Details" : "View Details"}
                <FontAwesomeIcon icon={faAngleDoubleRight} />
              </div>
            </div> */}
          {/* </div> */}
        </div>
        {/* {eventProgress === 'resultAnnounced' && (
          <div className='row mt-5'>
            <div className='col'>
              <div className='cw-plain-card cw-plain-card-wrapper-top mr-2 mb-3'>
                <div className='cw-plain-card-wrapper-winners'>
                  <div className='header-text'>
                    STUDENTS WINNERS {isConsolidatedReport && <span>(Your School)</span>}
                  </div>
                  <div className='mt-5'>
                    <EventStudentWinnersList
                      selectedClass={selectedClass}
                      ref={instance => {
                        this.studentWinners = instance
                      }}
                      fromScreen='assessment-chart'
                      event={event}
                    />

                    <div
                      className='view-details cursor-pointer'
                      onClick={_ => this.viewDetails('winners', false)}
                    >
                      {isConsolidatedReport ? "Your School Details" : "View Details"}
                      <FontAwesomeIcon icon={faAngleDoubleRight} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )} */}
        {eventProgress === 'resultAnnounced' && this.getSurveryReportJSX()}
        {/* {!isConsolidatedReport && eventProgress === 'baseline' && (
          <div className='row mt-5'>
            <div className='col'>
              <div className='cw-plain-card cw-plain-card-wrapper-top mr-2 pb-5'>
                <div className='header-text mb-5'>COURSE COMPLETION</div>
                {eventReport.chartData && (
                  <ResponsiveContainer width={'100%'} height={400}>
                    <LineChart
                      data={eventReport.chartData}
                      margin={{
                        top: 5,
                        right: 30
                      }}
                    >
                      <CartesianGrid vertical={false} />
                      <XAxis dataKey='name' />
                      <YAxis
                        padding={{ right: 20 }}
                        axisLine={false}
                        dataKey='pv'
                      />
                      <Line
                        type='monotone'
                        dataKey='pv'
                        stroke='#19da4d'
                        strokeWidth={5}
                        activeDot={false}
                        dot={false}
                        legendType={'none'}
                      />
                    </LineChart>
                  </ResponsiveContainer>
                )}
                <div
                  className='view-details text-right mt-4 cursor-pointer mb-4 mr-4'
                  onClick={this.viewDetails}
                >
                  View Details <FontAwesomeIcon icon={faAngleDoubleRight} />
                </div>
                <div className='chart-legends'>
                  <div className='legent-title vertical-text pt-2'>
                    Students{' '}
                    <FontAwesomeIcon icon={faArrowDown} color='#535353' />
                  </div>
                  <div className='legent-title pl-3'>
                    Qualifying course completion %{' '}
                    <FontAwesomeIcon icon={faArrowRight} color='#535353' />
                  </div>
                </div>
              </div>
            </div>
          </div>
        )} */}

        {/* {eventProgress !== 'baseline' && (
          <div className='row mt-5'>
            <div className='col'>
              <div className='cw-plain-card cw-plain-card-wrapper-top mr-2 pb-5'>
                <div className='chart-title-container'>
                  <div className='chart-title-text mb-1'>
                    SKILL COMPARISON {isConsolidatedReport && <span>(All Schools)</span>}
                  </div>
                  <div className='chart-title-legend text-right'>
                    <span className='skill-list'>
                      <img
                        className='skill-img'
                        src={getImageSource(ImageConstants.KNOWLEDGE)}
                      />
                      <span className='skill-title'>Knowledge</span>
                    </span>
                    <span className='skill-list'>
                      <img
                        className='skill-img'
                        src={getImageSource(ImageConstants.CALCULATION)}
                      />
                      <span className='skill-title'>Calculation</span>
                    </span>
                    <span className='skill-list'>
                      <img
                        className='skill-img'
                        src={getImageSource(ImageConstants.MODELING)}
                      />
                      <span className='skill-title'>Modeling</span>
                    </span>
                    <span className='skill-list'>
                      <img
                        className='skill-img'
                        src={getImageSource(ImageConstants.COMPREHENSION)}
                      />
                      <span className='skill-title'>Comprehension</span>
                    </span>
                  </div>
                </div>

                <div className='skill-container pt-5'>
                  <div className='skill-img-container'>
                    <img
                      className='skill-img'
                      src={getImageSource(ImageConstants.KNOWLEDGE)}
                    />
                  </div>
                  {this.renderSkillChart(
                    performanceReport?.baselinePercentage?.knowledge,
                    performanceReport?.finishlinePercentage?.knowledge
                  )}
                </div>
                <div className='skill-container pt-5'>
                  <div className='skill-img-container'>
                    <img
                      className='skill-img'
                      src={getImageSource(ImageConstants.CALCULATION)}
                    />
                  </div>
                  {this.renderSkillChart(
                    performanceReport?.baselinePercentage?.calculation,
                    performanceReport?.finishlinePercentage?.calculation
                  )}
                </div>
                <div className='skill-container pt-5'>
                  <div className='skill-img-container'>
                    <img
                      className='skill-img'
                      src={getImageSource(ImageConstants.MODELING)}
                    />
                  </div>
                  {this.renderSkillChart(
                    performanceReport?.baselinePercentage?.modeling,
                    performanceReport?.finishlinePercentage?.modeling
                  )}
                </div>
                <div className='skill-container pt-5'>
                  <div className='skill-img-container'>
                    <img
                      className='skill-img'
                      src={getImageSource(ImageConstants.COMPREHENSION)}
                    />
                  </div>
                  {this.renderSkillChart(
                    performanceReport?.baselinePercentage?.comprehension,
                    performanceReport?.finishlinePercentage?.comprehension
                  )}
                </div>
                <div className='skill-legends'>
                  <div className='skill-list'>Baseline assessment</div>
                  <div className='skill-list'>Finishline assessment</div>
                </div>
                <div
                  className='view-details text-right mt-4 cursor-pointer mb-4 mr-4'
                  onClick={_ => this.viewDetails('performance')}
                >
                  Your School Details{' '}
                  <FontAwesomeIcon icon={faAngleDoubleRight} />
                </div>
              </div>
            </div>
          </div>
        )} */}
        {isConsolidatedReport && eventProgress !== 'baseline' && (
          <div className='row mt-5 evaluation-report assessment'>
            <div className='col'>
              <div className='cw-plain-card cw-plain-card-wrapper-top mr-2 pb-5'>
                <div className='chart-title-container'>
                  <div className='chart-title-text mb-1'>
                    PERFORMANCE PROGRESSION <span>(All Schools)</span>
                  </div>
                  <div className='chart-title-legend text-right'>
                    <span className='skill-list'>
                      <FontAwesomeIcon icon={faArrowUp} color='#6ae5d3' />
                      <span className='skill-title'>
                        Students progressed from lower to higher level
                      </span>
                    </span>
                    <span className='skill-list'>
                      <img
                        className='skill-img'
                        src={getImageSource(ImageConstants.SCHOLAR_BLACK)}
                      />
                      <span className='skill-title'>Number of Students</span>
                    </span>
                  </div>
                </div>
                <div className='row'>
                  <div className='report-card col-4'>
                    <div
                      className='report-card-header'
                      style={{ backgroundColor: '#8B8BF6' }}
                    >
                      <div className='row header-items'>
                        <div className='col-12 text-center'>
                          <span>
                            <span className='header-title'>Struggler</span> |{' '}
                            <strong>{'< 50 %'}</strong>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='report-card col-4'>
                    <div
                      className='report-card-header'
                      style={{ backgroundColor: '#FFBB7C' }}
                    >
                      <div className='row header-items'>
                        <div className='col-12 text-center'>
                          <span>
                            <span className='header-title pl-4'>
                              Proficient
                            </span>{' '}
                            | <strong>{'50%-80%'}</strong>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='report-card col-4'>
                    <div
                      className='report-card-header'
                      style={{ backgroundColor: '#80D2F4' }}
                    >
                      <div className='row header-items'>
                        <div className='col-12 text-center'>
                          <span>
                            <span className='header-title'>Advance</span> |{' '}
                            <strong>{'> 80 %'}</strong>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='row report-card-details'>
                  <div className='col-12 report-card-header'>
                    Baseline Assessment{' '}
                    <span>
                      <img
                        className='scholar-img'
                        src={getImageSource(ImageConstants.SCHOLAR_WHITE)}
                      />
                      {eventReportConsolidated?.baseline?.totalUsers || 0}
                    </span>
                  </div>
                  <div className='report-card-body col-4'>
                    <span>
                      <img
                        className='scholar-img-black'
                        src={getImageSource(ImageConstants.SCHOLAR_BLACK)}
                      />
                      {eventReportConsolidated?.baseline?.noviceUsers || 0}
                    </span>
                  </div>
                  <div className='report-card-body col-4'>
                    <span>
                      <img
                        className='scholar-img-black'
                        src={getImageSource(ImageConstants.SCHOLAR_BLACK)}
                      />
                      {eventReportConsolidated?.baseline?.proficientUsers || 0}
                    </span>
                  </div>
                  <div className='report-card-body col-4'>
                    <span>
                      <img
                        className='scholar-img-black'
                        src={getImageSource(ImageConstants.SCHOLAR_BLACK)}
                      />
                      {eventReportConsolidated?.baseline?.advancedUsers || 0}
                    </span>
                  </div>
                  <div className='col-12 report-card-header'>
                    Final Assessment{' '}
                    <span>
                      <img
                        className='scholar-img'
                        src={getImageSource(ImageConstants.SCHOLAR_WHITE)}
                      />
                      {eventReportConsolidated?.finishline?.totalUsers || 0}
                    </span>
                  </div>
                  <div className='report-card-body col-4'>
                    <span>
                      <img
                        className='scholar-img-black'
                        src={getImageSource(ImageConstants.SCHOLAR_BLACK)}
                      />
                      {eventReportConsolidated?.finishline?.noviceUsers || 0}
                    </span>
                  </div>
                  <div className='report-card-body col-4'>
                    <span>
                      <img
                        className='scholar-img-black'
                        src={getImageSource(ImageConstants.SCHOLAR_BLACK)}
                      />
                      {eventReportConsolidated?.finishline?.proficientUsers ||
                        0}
                    </span>
                    <span className='increase-count'>
                      <span>
                        <FontAwesomeIcon icon={faArrowUp} color='#6ae5d3' />
                      </span>
                      <img
                        className='scholar-img-black'
                        src={getImageSource(ImageConstants.SCHOLAR_BLACK)}
                      />
                      {eventReportConsolidated?.finishline
                        ?.improvedProficientUsers || 0}
                    </span>
                  </div>
                  <div className='report-card-body col-4'>
                    <span>
                      <img
                        className='scholar-img-black'
                        src={getImageSource(ImageConstants.SCHOLAR_BLACK)}
                      />
                      {eventReportConsolidated?.finishline?.advancedUsers || 0}
                    </span>
                    <span className='increase-count'>
                      <span>
                        <FontAwesomeIcon icon={faArrowUp} color='#6ae5d3' />
                      </span>
                      <img
                        className='scholar-img-black'
                        src={getImageSource(ImageConstants.SCHOLAR_BLACK)}
                      />
                      {eventReportConsolidated?.finishline
                        ?.improvedAdvancedUsers || 0}
                    </span>
                  </div>
                </div>
                {/* <div
                  className='view-details text-right mt-4 cursor-pointer mb-2 mr-4'
                  onClick={_ => this.viewDetails('evaluation')}
                >
                  View Details <FontAwesomeIcon icon={faAngleDoubleRight} />
                </div> */}
              </div>
            </div>
          </div>
        )}
        {/* {eventProgress !== 'baseline' && selectedClass !== 'All' && (
          <div
            className='skill-comparison row mt-5'
            ref={ref => (this.performanceProgression = ref)}
          >
            <div className='col'>
              <div className='cw-plain-card cw-plain-card-wrapper-top mr-2 pb-5'>
                <div className='header-text mb-5'>SKILL COMPARISON</div>
                <EvalutionReportV2
                  selectedClass={selectedClass}
                  ref={ref => (this.evaluationReport = ref)}
                  event={event}
                />
              </div>
            </div>
          </div>
        )} */}
        {isConsolidatedReport && eventProgress === 'resultAnnounced' && (
          <>
            <div className='row mt-5 learning-outcome-report'>
              <div className='col'>
                <div className='cw-plain-card cw-plain-card-wrapper-top mr-2 pb-5'>
                  <div className='header-text mb-5'>
                    VIEW LEARNING OUTCOME REPORT FOR
                  </div>
                  <div className='class-container'>
                    {classes?.map((c, index) => (
                      <div
                        key={index}
                        onClick={_ => this.onSelectClass(c.title)}
                        className={`class-title cursor-pointer py-2 mr-4 ${selectedClassName ===
                          c.title && 'class-active'}`}
                      >
                        {c.title}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
        {eventProgress === 'final_live' && (
          <div className='row mt-4 assign-homework'>
            <div className='col'>
              <div className='cw-plain-card cw-plain-card-wrapper-top mr-2 pb-5'>
                <div className='header-text text-center'>
                  <p>
                    <strong>
                      Assign a free Preparatory Course to your all your
                      students between grades 6 – 9 as homework.{' '}
                    </strong>
                  </p>
                  <p>
                    This course will help them further bridge any learning gap.
                    {/* and make them better prepared when they come back to school
                    after their summer break. The course includes an AI-driven
                    assessment to identify the learning gaps, and personalized
                    learning modules for each child to fill the same before
                    returning to school from the summer break. */}
                  </p>
                </div>
                <div className='divider-line mt-4 mb-4'></div>
                {/* Commented the classwise Homework assignment with selected Concepts */}
                {/* <div className='table-bg'>
                  {this.renderClasswiseHomeworkAssign()}
                </div> */}

                <div className='col text-center mt-4'>
                  <button
                    className={`cw-button-primary cw-button-homework`}
                    onClick={this.assignHomeworkByFixedConcept}
                  >
                    Assign Homework for All Classes
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    )
  }
}

export default AssessmentChart
